import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import {
  getRouterParamsId,
  getRouterQueryParamsModule,
  getRouterQueryParamsModuleId,
  getRouterQueryParamsType,
} from '@app/app.reducer';
import { attachmentsCreate } from '@app/collections/attachments';
import { getCandidatesSelectedId } from '@collections/candidates';
import * as FormActions from '@shared/form/store/form.actions';
import { AssociationType, AttachmentParams, AttachmentService } from '@shared/services';

@Component({
  selector: 'mojo-candidate-attachments-upload',
  templateUrl: './upload.container.html',
  styleUrls: ['./upload.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadContainerComponent {
  id$: Observable<number> = combineLatest([
    this.store.select(getRouterQueryParamsModuleId),
    this.store.select(getRouterParamsId),
  ]).pipe(
    map(([moduleId, routerId]) => (!!moduleId ? moduleId : routerId)),
    first(),
  );
  module$: Observable<{}> = this.store.pipe(select(getRouterQueryParamsModule));
  type$: Observable<AssociationType> = this.store.pipe(select(getRouterQueryParamsType));
  candidateId$: Observable<number> = this.store.select(getCandidatesSelectedId);
  uploadText$ = this.type$.pipe(
    filter((type) => !!type),
    map((type) =>
      type === AssociationType.RESUME ? 'Upload resume file here' : 'Upload file here',
    ),
  );
  associationTypes = AssociationType;
  file: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  form: UntypedFormGroup = new UntypedFormGroup({ file: this.file });

  constructor(
    public dialogRef: MatDialogRef<UploadContainerComponent>,
    private store: Store<{}>,
    private router: Router,
    private attachmentService: AttachmentService,
  ) {}

  upload(file: File, params: AttachmentParams) {
    if (this.attachmentService.isFileTooLarge(file)) {
      this.attachmentService.showAlertWhenTooLargeFiles(file.name);
    } else {
      const candidateId =
        params.associationType === AssociationType.RESUME ? params.candidateId : null;
      this.store.dispatch(
        attachmentsCreate({
          payload: {
            file,
            params,
            candidateId,
          },
        }),
      );
    }
    this.dialogRef.close();
    this.router.navigate([{ outlets: { modal: null } }]);
  }

  close() {
    this.store.dispatch(FormActions.formClose({}));
  }
}
